"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isItemHubDomainInternal = exports.isItemHubDomainExternal = exports.isItemHub = exports.findApplicationName = exports.findAppPath = void 0;
// To Find the Itemhub 
// const findAppPath = () => {
//   const localhostLists = ['localhost', 'localhost.target.com']
//   const isLocal = localhostLists.includes(window.location.hostname)
//   const dynamicPath = `/${window.location.pathname.split('/')[1]}`
//   return isLocal ? '' : isItemHubDomain() ? dynamicPath : ''
// }

const findAppPath = () => {
  const localhostLists = ['localhost', 'localhost.target.com'];
  const hostname = window.location.hostname;
  const isLocal = localhostLists.includes(hostname);
  if (isLocal) {
    return '';
  }
  const pathSegments = window.location.pathname.split('/');
  const dynamicPath = pathSegments[1] ? "/".concat(pathSegments[1]) : '';
  if (isItemHubDomainInternal() || isItemHubDomainExternal()) {
    return dynamicPath;
  }
  return '';
};

// To Find, IS Itemhub Internal Domain
exports.findAppPath = findAppPath;
const isItemHubDomainInternal = () => {
  const regex = /^https:\/\/itemhub\.(?:[a-zA-Z]+\.)?target\.com(?:\/.*)?$/i; // Itemhub Internal environment
  return regex.test(window.location.href);
};

// To Find, IS Itemhub External Domain
exports.isItemHubDomainInternal = isItemHubDomainInternal;
const isItemHubDomainExternal = () => {
  const regex = /^https:\/\/itemhub\.(?:[a-zA-Z]+\.)?partnersonline\.com(?:\/.*)?$/i;
  // const regex = /^https:\/\/[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.partnersonline\.com(\/.*)?$/i; // Itemhub External environment - Partners online
  return regex.test(window.location.href);
};

// To find the app is part of Itemhub
exports.isItemHubDomainExternal = isItemHubDomainExternal;
const isItemHub = exports.isItemHub = isItemHubDomainInternal() || isItemHubDomainExternal();
const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
const findApplicationName = () => {
  if (isItemHub) {
    const urlPath = window.location.pathname;
    let name = urlPath.replace(/^\/|\/$/g, '').split('/')[0];
    return capitalizeFirstLetter(name);
  }
  return '';
};
exports.findApplicationName = findApplicationName;